import Vue from 'vue/dist/vue.esm'
import VueRouter from 'vue-router/dist/vue-router.esm'

import shopfrontMain from '../components/shopfront/containers/frontpage_container.vue';
import productShowContainer from "../components/shopfront/containers/product_show";
import cartShowContainer from "../components/shopfront/containers/cart_show";
import checkoutContainer from "../components/shopfront/containers/checkout";
import orderComplete from "../components/shopfront/containers/order_complete";

Vue.use(VueRouter)

export const routes = [
  { path: '/', component: shopfrontMain, name: 'shopnetHome' },
  { path: '/product/:productId', component: productShowContainer, name: 'product' },
  { path: '/cart', component: cartShowContainer, name: 'cartShow' },
  { path: '/checkout', component: checkoutContainer },
  { path: '/complete', component: orderComplete, name: 'complete' }
]

export default new VueRouter({
  mode: 'history',
  routes: routes,
  base:  `/${window.location.pathname.split("/")[1]}`
})

